import styled from 'styled-components';

export const ModalTitle = styled.h3`
  width: 100%;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #888888;
`;

export const ModalText = styled.p`
  text-align: center;
`;

export const LabelFileInput = styled.label`
  height: 36.5px;
  padding: 6px 16px;
  background-color: #fff;
  color: #e38500;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid rgba(227, 133, 0, 0.5);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: background-color 0.2s, border-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #fefaf5;
    border: 1px solid #e38500;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileInfo = styled.div`
  max-width: 192px;
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  strong {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #004e9a;
  border: none;
  outline: none;
  border-radius: 4px;
  margin-right: 4;

  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    color: #00366b;
  }
`;
